module.exports = __webpack_public_path__ + "static/media/boek_04.49c612f8.png";